const ListDiv = ({ list, checkedValues, setCheckedValues }) => {

    const handleClick = (value) => {
        setCheckedValues(prev => 
            prev.includes(value) ? prev.filter(v => v !== value) : [...prev, value]
        );
    };

    return list.map((item) => (
        <p key={item} onClick={() => handleClick(item)}>
            {item} 
            <input 
                type="checkbox" 
                checked={checkedValues.includes(item)}
                value={item} 
                style={{ float: 'right' }} 
            />
        </p>
    ));
};

export default ListDiv;